import { Backdrop } from "@mui/material";
import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import CoreButton from "../CoreButton/CoreButton";
import { useTranslation } from "react-i18next";

const LockScreen = ({ text, cta = null, openTrigger, zIndex }) => {
  const { t } = useTranslation();
  const studioId = useSelector((state) => state.app.studioId);
  useEffect(() => {
    !studioId
      ? (document.body.style.overflow = "hidden")
      : (document.body.style.overflow = "unset");
    return () => (document.body.style.overflow = "unset");
  }, [studioId]);

  return (
    <Backdrop
      sx={{
        color: "black",
        zIndex: zIndex || 2,
        position: "absolute",
        backdropFilter: "blur(2px)",
        backgroundColor: "rgba(233, 233, 233, 0.50)",
        height: "100vh",
      }}
      open={openTrigger !== undefined ? openTrigger : !studioId}
    >
      <div className="flex flex-col items-center gap-4">
        <div className="font-semibold">{text}</div>
        {cta && (
          <div className="w-2/3 flex justify-center">
            <CoreButton
              testo={t("Search") + " " + t("Studio")}
              className={"btn-round"}
              onClick={cta}
            />
          </div>
        )}
      </div>
    </Backdrop>
  );
};

export default LockScreen;
